
import Component, { mixins } from 'vue-class-component'
import Mixin from '../../mixin'
import { Prop } from 'vue-property-decorator'
import { db } from '../../main'
import { URL_CLOUD_FUNCTIONS } from '@/firebase/init'
import axios from 'axios'

@Component
export default class EnableUser extends mixins(Mixin) {
  @Prop() user
  dialog_enable_user = false

  async updateUserStatus() {
    this.showNotification('loading', 'Procesando', 'Un momento por favor')
    const user = {
      disabled: false
    }

    console.log(user)
    try {
      const url = URL_CLOUD_FUNCTIONS + 'updateUser'
      const res = await axios.post(url, {
        uid: this.user.uid,
        user: user
      })
      this.showNotification('success', 'Éxito', 'Usuario habilitado')
      console.log(res)
      return res
    } catch (error) {
      this.showNotification(
        'fail',
        'Error',
        'Ocurrió un error al habilitar al usuario'
      )
      console.log(error)
      return null
    }
  }
}
